/* Nordhaus smooth feel layer. Behaviour only, no visual changes. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // iOS Safari only applies :active styles when a touch listener exists.
  document.addEventListener('touchstart', function () {}, { passive: true });

  // Press feedback, on pointer-down, instantly.
  // Uses the separate `scale` property via the Web Animations API, so it
  // stacks on top of the theme's own hover lifts and reveal animations
  // instead of replacing them. Release always starts from wherever the
  // press currently is, so quick taps never jump.
  var PRESS = [
    ['.nh .nh-btn, .nh-header-cta, .wt-button, .button, .shopify-payment-button__button, button[type="submit"]', 0.97],
    ['.nh-card, .nh-product, .nh-premium-mobile-card, .mega-menu__gallery__link', 0.985]
  ];
  var pressed = null;

  function liveScale(el) {
    var s = getComputedStyle(el).scale;
    var n = parseFloat(s);
    return s === 'none' || isNaN(n) ? 1 : n;
  }

  function animateScale(el, to, ms, ease) {
    var from = liveScale(el);
    if (el.__nhsAnim) el.__nhsAnim.cancel();
    var anim = el.animate([{ scale: String(from) }, { scale: String(to) }], { duration: ms, easing: ease, fill: 'forwards' });
    el.__nhsAnim = anim;
    if (to === 1) anim.onfinish = function () { if (el.__nhsAnim === anim) { anim.cancel(); el.__nhsAnim = null; } };
  }

  function release() {
    if (!pressed) return;
    animateScale(pressed, 1, 380, 'cubic-bezier(.2,.8,.2,1)');
    pressed = null;
  }

  if (!reduce && 'animate' in Element.prototype && CSS.supports('scale', '1')) {
    document.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || !e.target.closest) return;
      for (var i = 0; i < PRESS.length; i++) {
        var el = e.target.closest(PRESS[i][0]);
        if (el && !el.disabled) {
          release();
          pressed = el;
          animateScale(el, PRESS[i][1], 100, 'ease-out');
          return;
        }
      }
    }, { passive: true });
    ['pointerup', 'pointercancel', 'dragstart'].forEach(function (t) {
      document.addEventListener(t, release, { passive: true });
    });
    window.addEventListener('blur', release);
    window.addEventListener('pagehide', release);
  }

  // Pages load before the click finishes.
  // When someone hovers or starts tapping a link, the browser quietly fetches
  // that page's HTML so it opens almost instantly. Prefetch only: no scripts
  // run and no analytics fire until the page is really opened.
  var SKIP = /\/(cart|checkout|checkouts|account|apps|services|tools)(\/|$)|\/(products|collections)\/[^?#]*\.(js|json)|[?&](add|variant)=|\/challenge/i;

  if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
    var rules = document.createElement('script');
    rules.type = 'speculationrules';
    rules.textContent = JSON.stringify({
      prefetch: [{
        source: 'document',
        where: {
          and: [
            { href_matches: '/*' },
            { not: { href_matches: ['/cart*', '/checkout*', '/checkouts/*', '/account*', '/apps/*', '/services/*', '/tools/*'] } },
            { not: { selector_matches: '[rel~="nofollow"], [target="_blank"], [download]' } }
          ]
        },
        eagerness: 'moderate'
      }]
    });
    document.head.appendChild(rules);
  } else {
    // Fallback for browsers without speculation rules.
    var done = new Set();
    var prefetch = function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin || url.hash && url.pathname === location.pathname) return;
      if (SKIP.test(url.pathname + url.search) || done.has(url.href)) return;
      done.add(url.href);
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url.href;
      document.head.appendChild(link);
    };
    document.addEventListener('pointerover', function (e) {
      var t = e.target;
      clearTimeout(t.__nhsT);
      t.__nhsT = setTimeout(function () { prefetch(e); }, 65);
      t.addEventListener('pointerout', function () { clearTimeout(t.__nhsT); }, { once: true });
    }, { passive: true });
    document.addEventListener('touchstart', prefetch, { passive: true });
  }

  // Soft image arrival: only for images still loading, never ones already shown.
  // Product cards with hover image swaps already animate opacity, so skip them.
  var SKIP_IMG = '.nh-product__media img, .wt-product__gallery img, .swiper img, .wt-brands img, [class*="carousel"] img, .wt-header img, .nhs-nofade';

  function soften(img) {
    if (reduce || img.__nhs || img.complete || img.matches(SKIP_IMG)) return;
    img.__nhs = true;
    img.classList.add('nhs-fade');
    var show = function () { img.classList.add('nhs-in'); };
    img.addEventListener('load', show, { once: true });
    img.addEventListener('error', show, { once: true });
    // Never leave an image hidden: once it is on screen, show it within 2.5s
    // whether or not it has finished loading.
    if (safety) safety.observe(img); else setTimeout(show, 4000);
  }

  var safety = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      safety.unobserve(en.target);
      setTimeout(function () { en.target.classList.add('nhs-in'); }, 2500);
    });
  }) : null;

  // First pass only touches images below the fold, so nothing the visitor
  // can already see ever blinks out.
  function scan(root) {
    var fold = window.innerHeight * 1.1;
    root.querySelectorAll('main img').forEach(function (img) {
      if (img.getBoundingClientRect().top > fold) soften(img);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  // Images added later (sections, quick view, infinite scroll).
  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'IMG' && n.closest('main')) soften(n);
          else if (n.querySelectorAll) n.querySelectorAll('img').forEach(function (i) { if (i.closest('main')) soften(i); });
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
